import { render, staticRenderFns } from "./ReservationServices.vue?vue&type=template&id=0d8e551e&"
import script from "./ReservationServices.vue?vue&type=script&lang=ts&"
export * from "./ReservationServices.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationServices.vue?vue&type=style&index=0&lang=postcss&scoepd=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports